const POPOVER_GAP = 8;
export const POPOVER_EDGE = 8;
export const POPOVER_MIN_HEIGHT = 100;
export const POPOVER_MAX_HEIGHT = 280;

export function centeredLeft(anchor: DOMRect, width: number): number {
  const vw = document.documentElement.clientWidth;
  const centered = anchor.left + anchor.width / 2 - width / 2;
  return Math.max(POPOVER_EDGE, Math.min(centered, vw - width - POPOVER_EDGE));
}

export function placePopover(
  anchor: DOMRect,
  width: number,
  height: number,
): { top: number; left: number; maxHeight: number } {
  const vh = document.documentElement.clientHeight;
  const spaceBelow = vh - POPOVER_EDGE - (anchor.bottom + POPOVER_GAP);
  const spaceAbove = anchor.top - POPOVER_GAP - POPOVER_EDGE;
  let top: number;
  let maxHeight: number;
  if (height <= spaceBelow || spaceBelow >= spaceAbove) {
    maxHeight = Math.max(spaceBelow, POPOVER_MIN_HEIGHT);
    top = Math.max(POPOVER_EDGE, Math.min(anchor.bottom + POPOVER_GAP, vh - POPOVER_EDGE - maxHeight));
  } else {
    maxHeight = Math.min(height, Math.max(spaceAbove, POPOVER_MIN_HEIGHT));
    top = Math.max(POPOVER_EDGE, anchor.top - POPOVER_GAP - maxHeight);
  }
  const left = centeredLeft(anchor, width);
  return { top, left, maxHeight };
}
